import React from 'react';
import { useLocation } from 'react-router-dom';

// A column detail opens as a panel over the page it was clicked on, not as a
// page of its own, so its `/column/<id>` URL counts as the same page here.
// Without this, clicking a column part-way down a long list scrolled the list
// back to the top underneath the user.
const pageKey = (pathname: string) =>
    pathname.replace(/\/column\/[^/]+\/?$/, '');

// See https://v5.reactrouter.com/web/guides/scroll-restoration */
const ScrollToTop: React.FunctionComponent = () => {
    const { pathname } = useLocation();
    const page = pageKey(pathname);

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [page]);

    return null;
};

export default ScrollToTop;
